jQuery(document).ready(function ($) {
  'use strict';

  $('.ipo-mdc-form--parsley-form .ipo-mdc-form-richtext-element a').mousedown(function (event) {
    if (event.which == 1 && event.target.href.length > 0) {
      window.location = event.target.href;
    }
  });
});